import React from 'react';
import Youtube from 'react-youtube';

import './REMOTION2020.css';
import Flipbook from '../components/Flipbook.js';

function REMOTION2020() {
  const _onReady = (event) => {
    // access to player in all event handlers via event.target
    const player = event.target;

    player
      .cuePlaylist({
        listType: 'playlist',
        list: 'PLKibaAPRN28qXQjJbcW2VUPIgf0D9Fuec',
        index: 0
      })
  };

  const opts = {};

  return (
    <div className='remotion-2020'>
      <div className='header'>
        <h1>rEMOTION Online Theatre Festival 2020 </h1>
      </div>
      <div className='youtube-player'>
        <Youtube opt={opts} onReady={_onReady}/>
      </div>
      <div className='header'>
        <h2>Playbill</h2>
      </div>
      <div>
        <Flipbook />
      </div>
    </div>
  )
}

export default REMOTION2020;
